import { Box, Grid, Icon, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  api_request,
  setCommonReducer,
} from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  multiDocument,
  projectCreateNeeded,
} from "../../config/constants";
import {
  BILL_UPLOAD_ERROR,
  BILL_UPLOAD_SUCCESS,
  CREATE_PROJECT_ERROR,
  CREATE_PROJECT_SUCCESS,
} from "../../store/types/billTypes";
import { setBillReducer } from "../../store/actions/billActions";
import { useLocation, useNavigate } from "react-router";
import {
  FORBIDDEN_ACTION,
  GET_BASIC_ERROR,
  GET_BASIC_SUCCESS,
  UNAUTHORIZED_USER,
} from "../../store/types/authTypes";
import { theme } from "../../config/theme";
import Swal from "sweetalert2";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import CoreModal from "../../core/layouts/CoreModal";
import CoreLinearProgress from "../../core/Loader/CoreLinearProgress";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { getApiHeader } from "../../helper/apiActionHelper";
import { backendUrl } from "../../config/api";
import CoreSelect from "../../core/inputs/CoreSelect";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreInput from "../../core/inputs/CoreInput";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import {
  GET_LATEST_PROJECTS_ERROR,
  GET_LATEST_PROJECTS_SUCCESS,
} from "../../store/types/commonTypes";
import { CoreCustomPicker } from "../../core/inputs/CoreCustomPicker";

export default function ComparatorUpload(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tool = location.pathname.split("/")[1];

  const [file, setFile] = useState(null);
  const [description, setDescription] = useState(null);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [tempData, setTempData] = useState(null);
  const [isMulti, setMulti] = useState(false);
  const [project, setProject] = useState(null);
  const [projectModal, setProjectModal] = useState(false);
  const [projectName, setProjectName] = useState("");

  const auth = useSelector((state) => state?.auth);
  const billUploadSuccess = useSelector(
    (state) => state?.bill?.billUploadSuccess,
  );
  const billUploadError = useSelector((state) => state?.bill?.billUploadError);
  const billUploadMessage = useSelector(
    (state) => state?.bill?.billUploadMessage,
  );
  const billUploadData = useSelector((state) => state?.bill?.billUploadData);
  const submitBillSuccess = useSelector(
    (state) => state?.bill?.submitBillSuccess,
  );
  const submitBillError = useSelector((state) => state?.bill?.submitBillError);
  const submitBillMessage = useSelector(
    (state) => state?.bill?.submitBillMessage,
  );
  const docTypes = useSelector((state) => state.common.toolDocTypes);
  const userSettings = useSelector((state) => state?.common?.userSettings);
  const projects = useSelector((state) => state?.common?.projectsLatest);
  const newProjectId = useSelector((state) => state?.bill?.newProjectId);

  const projectCreate = userSettings?.find(
    (set) => set.name === projectCreateNeeded,
  )
    ? userSettings?.find((set) => set.name === projectCreateNeeded)?.value
        ?.enabled
    : true;

  useEffect(() => {
    getLatestProjects();
  }, []);

  useEffect(() => {
    if (file && projectCreate) {
      setProjectModal(true);
    }
    if (file && (project || !projectCreate)) {
      handlePdfUpload();
    }
  }, [file, project]);

  useEffect(() => {
    if (newProjectId) {
      setProject(newProjectId);
      getLatestProjects();
    }
  }, [newProjectId]);

  const getLatestProjects = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/projects/latest",
        {},
        {},
        null,
        GET_LATEST_PROJECTS_SUCCESS,
        GET_LATEST_PROJECTS_ERROR,
        true,
        false,
      ),
    );
  };
  useEffect(() => {
    if (billUploadSuccess) {
      dispatch(
        api_request(
          API_METHOD_GET,
          "/business/individual/ProfileBasic",
          {},
          {
            _defaultFilter: encodeURIComponent(
              JSON.stringify({ userId: auth?.uid }),
            ),
          },
          null,
          GET_BASIC_SUCCESS,
          GET_BASIC_ERROR,
          true,
          false,
        ),
      );
      // alert(billUploadMessage);
      if (
        billUploadData?.docId ||
        tool === "tender-management" ||
        tool === "pricebook-management"
      ) {
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            docId: billUploadData.docId,
            docType: billUploadData.Type,
            newProjectId: null,
          }),
        );
        if (billUploadData.docId) {
          navigate("/" + tool + "/single");
        } else {
          navigate("/" + tool + "/unsaved/single");
        }
      } else {
        let uniqueId = billUploadData?.uniqueId;
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            billUploadData: null,
            jobBillsData: null,
            newProjectId: null,
          }),
        );
        Swal.fire({
          title: "Processing Started, ID:" + uniqueId,
          text: "You will be notified via email once done",
          icon: "success",
          confirmButtonColor: theme.palette.primary.main,
        });
        navigate("/" + tool + "/docs/view");
      }
    }
    if (billUploadError) {
      alert(billUploadMessage);
      dispatch(setBillReducer({ billUploadError: false }));
    }
  }, [billUploadSuccess, billUploadError]);

  useEffect(() => {
    if (submitBillSuccess) {
      alert(submitBillMessage);
      dispatch(setBillReducer({ submitBillSuccess: false }));
    }
    if (submitBillError) {
      alert(submitBillMessage);
      dispatch(setBillReducer({ submitBillError: false }));
    }
  }, [submitBillSuccess, submitBillError]);

  const handlePdfUpload = (e) => {
    e?.preventDefault();

    let requestBody = {
      file: file,
      tool: tool,
      multipleDocument: false,
      projectId: project,
    };
    console.log("file upload ", file, requestBody);
    if (file.size > 50 * 1024 * 1024) {
      if (file.size > 5 * 1024 * 1024 * 1024) {
        alert("Maximum 5Gb file allowed");
        return;
      }
      setUploadModal(true);
      const chunkSize = 5 * 1024 * 1024; // 5MB (adjust based on your requirements)
      const totalChunks = Math.ceil(file.size / chunkSize);
      let chunkNumber = 0;
      let chunkDir = "";
      let start = 0;
      let end = start + chunkSize;

      const uploadNextChunk = async () => {
        console.log("Uploading next ", start, end, chunkNumber);

        // if (!uploadModal && chunkNumber > 1) {
        //   console.log("CANCELLING!!!!!!!");

        //   return;
        // }
        if (end <= file.size && start < end) {
          const chunk = file.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk);
          formData.append("chunkNumber", chunkNumber);
          formData.append("totalChunks", totalChunks);
          formData.append("originalname", file.name);
          formData.append("chunkDir", chunkDir);
          formData.append("tool", tool);
          if (chunkNumber + 1 === totalChunks) {
            dispatch(setCommonReducer({ loading: true }));
            dispatch(
              setBillReducer({
                billUploadLoading: true,
                billUploadSuccess: false,
                billUploadError: false,
                billUploadMessage: null,
                billUploadData: null,
              }),
            );
          }
          // let retry = 5;
          // while (retry > 0) {
          const headers = getApiHeader("POST", true, true);
          fetch(backendUrl + "/chunk/upload", {
            method: "POST",
            body: formData,
            headers: headers,
          })
            .then((response) => {
              if (response.status === 200) {
                response.json().then((data) => {
                  console.log(data, data?.data?.chunkDir);
                  if (chunkNumber === 0) {
                    chunkDir = data?.data?.chunkDir;
                  }
                  const percentage = Math.floor(
                    ((chunkNumber + 1) / totalChunks) * 100,
                  );
                  setUploadPercentage(percentage);
                  chunkNumber++;
                  start = end;
                  end = start + Math.min(chunkSize, file.size - end);
                  setTempData(data);
                  uploadNextChunk();
                });
              } else if (response.status === 401) {
                dispatch({ type: UNAUTHORIZED_USER });
              } else if (response.status === 403) {
                dispatch({ type: FORBIDDEN_ACTION });
              } else {
                console.error("Error uploading chunk:");
                setUploadPercentage(0);
                setUploadModal(false);
                setFile(null);
                dispatch(setCommonReducer({ loading: false }));
                setFile(null);
                alert("Internal error in file upload");
              }
            })
            .catch((error) => {
              console.error("Error uploading chunk:", error);
              dispatch(setCommonReducer({ loading: false }));
              setUploadPercentage(0);
              setUploadModal(false);
              setFile(null);
              alert("Internal error in file upload");
            });
          // }
        } else {
          dispatch(setCommonReducer({ loading: false }));
          setUploadPercentage(100);
          setUploadModal(false);
          dispatch(
            setBillReducer({
              billUploadLoading: false,
              billUploadSuccess: true,
              billUploadError: false,
              billUploadMessage: tempData?.message,
              billUploadData: tempData?.data,
            }),
          );
        }
      };

      uploadNextChunk();
    } else {
      dispatch(
        api_request(
          API_METHOD_POST,
          "/doc/upload",
          requestBody,
          {},
          null,
          BILL_UPLOAD_SUCCESS,
          BILL_UPLOAD_ERROR,
          true,
          true,
        ),
      );
    }
  };

  const createNewProject = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/project/new",
        { name: projectName, label: projectName },
        {},
        null,
        CREATE_PROJECT_SUCCESS,
        CREATE_PROJECT_ERROR,
        true,
        false,
      ),
    );
  };

  console.log(
    "billUploadData DATA",
    project,
    newProjectId,
    file,
    projectCreate,
  );
  return (
    <>
      <CoreModal
        open={uploadModal}
        handleClose={() => {}}
        title={"Uploading large file"}
      >
        <CoreLinearProgress value={uploadPercentage} />
        <Box
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}
        >
          <CoreContainedButton
            color="error"
            onClick={() => {
              setUploadModal(false);
            }}
          >
            Cancel
          </CoreContainedButton>
        </Box>
      </CoreModal>
      <CoreModal
        open={projectModal}
        width={800}
        style={{ minHeight: "20vh" }}
        handleClose={() => {}}
        title={
          "Link with " + (props?.layout === "education" ? "Course" : "Project")
        }
      >
        <Box style={{ padding: 8, marginTop: 16 }}>
          <Grid container spacing={1}>
            <Grid xs={5}>
              <CoreCustomPicker
                label={props?.layout === "education" ? "Course" : "Project"}
                data={projects}
                onPick={(row) => {
                  setProject(row.id);
                  setProjectModal(false);
                }}
              />
              {/* <CoreTypographyBody1>Choose from existing</CoreTypographyBody1>

              <CoreInput
                label="Select Project"
                endAdornment={<Icon>search</Icon>}
              />
              <Box
                style={{ maxHeight: 200, minHeight: 200, overflowY: "auto" }}
              >
                {projects.map((row) => (
                  <MenuItem
                    onClick={() => {
                      setProject(row.id);
                      setProjectModal(false);
                    }}
                  >
                    {row.name}
                  </MenuItem>
                ))}
              </Box> */}
            </Grid>
            <Grid xs={2}>
              <CoreTypographyBody1 style={{ textAlign: "center" }}>
                Or,{" "}
              </CoreTypographyBody1>
            </Grid>
            <Grid xs={5}>
              <CoreTypographyBody1 style={{ marginBottom: 8 }}>
                Create New{" "}
                {props?.layout === "education" ? "Course" : "Project"}
              </CoreTypographyBody1>
              <CoreInput
                label={
                  props?.layout === "education" ? "Course name" : "Project name"
                }
                onChange={(e) => {
                  setProjectName(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </Box>

        <CoreButtonContainer>
          <CoreContainedButton
            color="error"
            onClick={() => {
              setProjectModal(false);
            }}
          >
            Cancel
          </CoreContainedButton>
          <CoreContainedButton
            style={{ marginLeft: 8 }}
            onClick={createNewProject}
          >
            Continue
          </CoreContainedButton>
        </CoreButtonContainer>
      </CoreModal>
      <div
        style={{
          height: "calc(100vh - 68px - 4px)",
          width: "calc(100% + 32px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "-8px",
          marginTop: "-8px",
        }}
      >
        <CoreFileUploader
          tool={tool}
          handleChange={(file) => {
            if (file) {
              setFile(file);
            }
          }}
          // isMulti={uploadMultiple}
          // allowedFiles={["zip"]}
          isMultiChecked={isMulti}
          onMultiChange={() => {
            setMulti(!isMulti);
          }}
        />
      </div>
    </>
  );
}
